import React, { Component } from 'react'
import getEventValue from '../func/getEventValue'
import naturalCompare from '../../../functions/naturalCompare'
import SortableEventsList from '../present/SortableEventsList'

class SortableEventsListContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeSortId: 'date',
            sortSettings: {
                date: {
                    name: 'Datum',
                    type: 'date',
                    reverse: false,
                    sortable: true,
                },
                created_at: {
                    name: 'Eingang',
                    type: 'date',
                    reverse: false,
                    sortable: true,
                },
                request_id: {
                    name: 'Nummer',
                    type: 'string',
                    reverse: false,
                    sortable: true,
                },
                name: {
                    name: 'Name',
                    type: 'string',
                    reverse: false,
                    sortable: true,
                },
                status: {
                    name: 'Status',
                    type: 'string',
                    reverse: false,
                    sortable: true,
                }
            }
        }

        this.onSortList = this.onSortList.bind(this)
    }

    getSortedItems() {
        const { eventsData } = this.props
        const {activeSortId, sortSettings } = this.state

        if(!eventsData.hasOwnProperty('order') || 0 === eventsData.order.length) {
            return false
        }

        const itemsArray = Object.values(eventsData.items)
        const activeSortSettings = sortSettings[activeSortId]

        if('string' === activeSortSettings.type) {
            itemsArray.sort((a, b) => {
                const valueA = getEventValue(activeSortId, a)
                const valueB = getEventValue(activeSortId, b)
                
                return naturalCompare(valueB, valueA)
            })
        } else if('date' === activeSortSettings.type) {
            itemsArray.sort((a, b) => {
                const valueA = getEventValue(activeSortId, a)
                const valueB = getEventValue(activeSortId, b)

                return new Date(valueB) - new Date(valueA);
            })
        }

        if(activeSortSettings.reverse) {
            itemsArray.reverse()
        }

        return itemsArray
    }

    onSortList(id) {
        this.setState(prevState => ({
            ...prevState,
            activeSortId: id,
            ...(id === prevState.activeSortId && {sortSettings: {
                ...prevState.sortSettings,
                [id]: {
                    ...prevState.sortSettings[id],
                    reverse: !prevState.sortSettings[id].reverse
                }
            }}),
        }))
    }

    render() {
        const { eventsStatus, eventsError, settingsStatus, settingsError, canDeleteEvent, displayOverlay, setDisplayOverlay, onFetchEvents, onDeleteEvent } = this.props 
        const { activeSortId, sortSettings } = this.state
        const sortedListItems = this.getSortedItems()

        return <SortableEventsList 
            eventsStatus={eventsStatus}
            eventsError={eventsError}
            settingsStatus={settingsStatus}
            settingsError={settingsError}
            canDeleteEvent={canDeleteEvent}
            activeSortId={activeSortId}
            sortSettings={sortSettings}
            sortedListItems={sortedListItems}
            displayOverlay={displayOverlay}
            setDisplayOverlay={setDisplayOverlay}
            onSortList={this.onSortList}
            onFetchEvents={onFetchEvents}
            onDeleteEvent={onDeleteEvent}
        />
    }
}

export default SortableEventsListContainer